
      import serviceWorkerRegisterer from "./src/service-worker/registerer.js";

      (async () => {
        await serviceWorkerRegisterer();
        import("./src/index.tsx");
      })();
    